import { useEffect, useState } from "react";
import type { Psychologist } from "../types/psychologist";
import { usePsychologistContext } from "../contexts/PsychologistContext";

export const usePsychologistData = (): Psychologist | null => {
  const [psychologist, setPsychologist] = useState<Psychologist | null>(null);
  const { psychologist: ctxPsychologist } = usePsychologistContext();

  useEffect(() => {
    let cancelled = false;
    try {
      if (ctxPsychologist) {
        if (!cancelled) {
          const mapped: Psychologist = {
            id: ctxPsychologist.id,
            nickname: ctxPsychologist.nickname,
            currency: ctxPsychologist.currency,
            payment_method: ctxPsychologist.paymentMethod,
            ranking_category:
              ctxPsychologist.rankingCategory as Psychologist["ranking_category"],
            ranking_score: ctxPsychologist.rankingScore,
            process_limit: ctxPsychologist.processLimit,
            process_limit_prefered: ctxPsychologist.processLimitPrefered,
            status: ctxPsychologist.statusId ? { id: ctxPsychologist.statusId } : undefined,
            name: ctxPsychologist.name,
            last_name: ctxPsychologist.lastName,
            specialties: ctxPsychologist.specialties,
            timezone: ctxPsychologist.timezone,
          } as Psychologist;
          setPsychologist(mapped);
        }
        return;
      }

      const storedPsychologist = localStorage.getItem('psi-connect-psychologist');
      if (storedPsychologist && !cancelled) {
        try {
          JSON.parse(storedPsychologist);
        } catch {
          localStorage.removeItem('psi-connect-psychologist');
        }
      }
    } catch {
      if (!cancelled) setPsychologist(null);
    }
    return () => { cancelled = true; };
  }, [ctxPsychologist]);

  return psychologist;
};
